import { z } from 'zod';
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const isDateValid = (date: string) => {
    return dayjs(date, 'YYYY-MM-DDTHH:mm:ss', true).isValid();
}

const contractCustomerShape = z.object({
    id: z.number(),
    name: z.string().optional(),
})

export const DownloadSchema = z.object({
    last30days: z
        .boolean(),
    start_date: z
        .string()
        .optional()
        .refine((date) => (
            date ? isDateValid(date) : true
        ), {
            message: 'Invalid date format. Expected YYYY-MM-DDTHH:mm:ss.',
            path: ['start_date'],
        }),
    end_date: z
        .string()
        .optional()
        .refine((date) => (
            date ? isDateValid(date) : true
        ), {
            message: 'Invalid date format. Expected YYYY-MM-DDTHH:mm:ss.',
            path: ['start_date'],
        }),
    customers: z
        .array(contractCustomerShape)
        .optional(),
    contracts: z
        .array(contractCustomerShape)
        .optional(),
    applications: z
        .array(z
            .number()
            .refine(val => [2, 3, 4].includes(val), {
                message: 'An application provided did not match any internal application references.',
            })
        )
        .optional(),
    format: z
        .enum(['csv', 'json'])
        .optional(),
})
    .refine((data) => (
        data.last30days ? true : (!!data.start_date && !!data.end_date)
    ), {
        message: 'Start and End dates are required.',
        path: ['end_date', 'start_date'],
    })
    .refine((data) => {
        if (data.start_date && data.end_date) {
            return dayjs(data.start_date).isBefore(dayjs(data.end_date));
        }
        return true;
    }, {
        message: 'Start date must be before end date.',
        path: ['end_date'],
    });

export type Download = z.infer<typeof DownloadSchema>;
